import { render } from "./ParamsItem.vue?vue&type=template&id=c5afd10a"
import script from "./ParamsItem.vue?vue&type=script&lang=js"
export * from "./ParamsItem.vue?vue&type=script&lang=js"

import "./ParamsItem.vue?vue&type=style&index=0&id=c5afd10a&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__